import { o as t } from "./object-create.js";
import { d as e } from "./define-built-in-accessor.js";
import { d as i } from "./define-built-ins.js";
import { f as r } from "./function-bind-context.js";
import { a as s } from "./an-instance.js";
import { i as o } from "./is-null-or-undefined.js";
import { i as n } from "./iterate.js";
import { i as a } from "./iterator-define.js";
import { c as f } from "./create-iter-result-object.js";
import { s as u } from "./set-species.js";
import { d as v } from "./descriptors.js";
import { i as d } from "./internal-metadata.js";
import { i as c } from "./internal-state.js";
var l = d.fastKey,
  m = c.set,
  p = c.getterFor,
  x = {
    getConstructor: function getConstructor(a, f, u, d) {
      var c = a(function (e, i) {
          s(e, x), m(e, {
            type: f,
            index: t(null),
            first: void 0,
            last: void 0,
            size: 0
          }), v || (e.size = 0), o(i) || n(i, e[d], {
            that: e,
            AS_ENTRIES: u
          });
        }),
        x = c.prototype,
        h = p(f),
        j = function j(t, e, i) {
          var r,
            s,
            o = h(t),
            n = g(t, e);
          return n ? n.value = i : (o.last = n = {
            index: s = l(e, !0),
            key: e,
            value: i,
            previous: r = o.last,
            next: void 0,
            removed: !1
          }, o.first || (o.first = n), r && (r.next = n), v ? o.size++ : t.size++, "F" !== s && (o.index[s] = n)), t;
        },
        g = function g(t, e) {
          var i,
            r = h(t),
            s = l(e);
          if ("F" !== s) return r.index[s];
          for (i = r.first; i; i = i.next) if (i.key == e) return i;
        };
      return i(x, {
        clear: function clear() {
          for (var t = h(this), e = t.index, i = t.first; i;) i.removed = !0, i.previous && (i.previous = i.previous.next = void 0), delete e[i.index], i = i.next;
          t.first = t.last = void 0, v ? t.size = 0 : this.size = 0;
        },
        delete: function _delete(t) {
          var e = h(this),
            i = g(this, t);
          if (i) {
            var r = i.next,
              s = i.previous;
            delete e.index[i.index], i.removed = !0, s && (s.next = r), r && (r.previous = s), e.first == i && (e.first = r), e.last == i && (e.last = s), v ? e.size-- : this.size--;
          }
          return !!i;
        },
        forEach: function forEach(t) {
          for (var e, i = h(this), s = r(t, arguments.length > 1 ? arguments[1] : void 0); e = e ? e.next : i.first;) for (s(e.value, e.key, this); e && e.removed;) e = e.previous;
        },
        has: function has(t) {
          return !!g(this, t);
        }
      }), i(x, u ? {
        get: function get(t) {
          var e = g(this, t);
          return e && e.value;
        },
        set: function set(t, e) {
          return j(this, 0 === t ? 0 : t, e);
        }
      } : {
        add: function add(t) {
          return j(this, t = 0 === t ? 0 : t, t);
        }
      }), v && e(x, "size", {
        configurable: !0,
        get: function get() {
          return h(this).size;
        }
      }), c;
    },
    setStrong: function setStrong(t, e, i) {
      var r = e + " Iterator",
        s = p(e),
        o = p(r);
      a(t, e, function (t, e) {
        m(this, {
          type: r,
          target: t,
          state: s(t),
          kind: e,
          last: void 0
        });
      }, function () {
        for (var t = o(this), e = t.kind, i = t.last; i && i.removed;) i = i.previous;
        return t.target && (t.last = i = i ? i.next : t.state.first) ? "keys" == e ? f(i.key, !1) : "values" == e ? f(i.value, !1) : f([i.key, i.value], !1) : (t.target = void 0, f(void 0, !0));
      }, i ? "entries" : "values", !i, !0), u(e);
    }
  };
export { x as c };